const defaultState = {
  snack: null,
  pathname: '',
  snackType: null,
  isLoading: false,
  modalOpened: null,
}


export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'REMOVE_SNACK': return {
      ...state,
      snack: null,
      snackType: null,
    }

    case 'LOGIN':
    case 'GET_CLIENT':
    case 'GET_USER':
    case 'GET_LIST':
    case 'SUBSCRIBE':
    case 'GET_CASTING':
    case 'UPDATE_LIST':
    case 'EDIT_CASTING':
    case 'GET_CASTINGS':
    case 'CREATE_CASTING':
    case 'EDIT_CASTING_PROFILE':
    case 'LOADING': return {
      ...state,
      isLoading: true,
    }

    case 'LOGIN_SUCCESS': return {
      ...state,
      isLoading: false,
      pathname: state.pathname === '' || state.pathname === '/' ? '/admin' : state.pathname,
    }

    case 'EDIT_USER':
    case 'GET_CLIENT_SUCCESS':
    case 'EDIT_CASTING_SUCCESS':
    case 'GET_USER_SUCCESS':
    case 'GET_CASTING_SUCCESS':
    case 'GET_CASTINGS_SUCCESS':
    case 'UPDATE_LIST_SUCCESS':
    case 'GET_LIST_SUCCESS':
    case 'EDIT_CASTING_PROFILE_SUCCESS':
    case 'UNLOAD': return {
      ...state,
      isLoading: false,
    }

    case 'CREATE_CASTING_SUCCESS': return {
      ...state,
      isLoading: false,
      snackType: 'success',
      snack: 'Casting successfuly created',
    }

    case 'NAVIGATION': return {
      ...state,
      pathname: action.pathname,
    }

    case 'GET_CLIENT_ERROR':
    case 'EDIT_CASTING_ERROR':
    case 'GET_CASTING_ERROR':
    case 'GET_CASTINGS_ERROR':
    case 'LOGIN_ERROR':
    case 'GET_LIST_ERROR':
    case 'UPDATE_LIST_ERROR':
    case 'CREATE_CASTING_ERROR':
    case 'EDIT_CASTING_PROFILE_ERROR':
    case 'SNACK_ERROR': return {
      ...state,
      isLoading: false,
      snackType: 'error',
      snack: action.message,
    }

    case 'SNACK_SUCCESS': return {
      ...state,
      snackType: 'success',
      snack: action.message,
    }

    case 'OPEN_DRAWER': return {
      ...state,
      drawerOpened: true,
    }

    case 'CLOSE_DRAWER': return {
      ...state,
      drawerOpened: false,
    }

    case 'OPEN_MODAL': return {
      ...state,
      modalOpened: action.modal,
    }

    case 'CLOSE_MODAL': return {
      ...state,
      modalOpened: null,
    }

    case 'LOGOUT': return {
      ...state,
      pathname: '/',
    }

    default: return state
  }
}
